"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logout = logout;
/**
 * Причины логаута `HeaderLogoutButtonClick`, `UserInactivity`, `AlertPageLogoutButtonClick` должны использоваться только в newclick-host-ui
 */
function logout(reason) {
    if (typeof window !== 'undefined') {
        window?.logout(reason);
    }
}
